<template>
    <NuxtLayout name="malt-full-layout">
        <KeepAlive>
            <slot />
        </KeepAlive>
    </NuxtLayout>
</template>
